export function addReftag(url, to, where) {
    const reftag = `vc_${to || 'xx'}_${where || 'xx'}`;
    const newUrl = new URL(url, window.location.href);
    newUrl.searchParams.set('ref_', reftag);
    return newUrl.toString();
}
